import styled from '@emotion/styled'
import { Link as RouterLink } from 'react-router-dom'

/**
 * Style the Router Link component so that it behaves more like a button.
 * Avoids the need to pass link props all the way through the StatusChecksHeader component.
 *
 * Usage:
 * When used as a child in a flex container, it takes up the sibling's height which is problematic.
 * The solution is to put alignItems="flex-start" on the parent flex container.
 */
export const StyledRouterLink = styled(RouterLink)`
  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    color: white;
    text-decoration: none;
  }
`
